import { positionsTypes } from "../constantes/actionTypes"

const initialState = []

export const positions = (state = initialState, action) => {
    switch (action.type) {
        case positionsTypes.GET_ALL_POSITIONS_SUCCESS:
            return action.payload
        case positionsTypes.GET_ALL_POSITIONS_FAILURE:
            return initialState
        case positionsTypes.UPDATE_POSITION_SUCCESS:
            const updatePosition = state.map(item => {
                if (item.id_TipoCargo === action.payload.id_TipoCargo)
                    return action.payload
                return item
            })
            return updatePosition
        case positionsTypes.DELETE_POSITION_SUCCESS:
            return state.filter(item => item.id_TipoCargo !== action.payload.id_TipoCargo)
        case positionsTypes.NEW_POSITION_SUCCESS:
            return [...state, action.payload]
        case positionsTypes.UPDATE_POSITION_FAILURE:
        case positionsTypes.DELETE_POSITION_FAILURE:
        case positionsTypes.NEW_POSITION_FAILURE:
            return state
        default:
            return state
    }
}